var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.469 0H2.53A2.532 2.532 0 0 0 0 2.531V24.47A2.532 2.532 0 0 0 2.531 27H24.47A2.532 2.532 0 0 0 27 24.469V2.53A2.532 2.532 0 0 0 24.469 0zm.843 24.469a.845.845 0 0 1-.843.843H2.53a.844.844 0 0 1-.843-.843V2.53c0-.466.377-.844.843-.844H24.47a.845.845 0 0 1 .843.844V24.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.425 14.776a.933.933 0 0 0-1.219 0l-1.987 1.79-3.706-3.34a.933.933 0 0 0-1.218 0l-6.048 5.45a.725.725 0 0 0-.182.842c.131.288.441.478.787.482h17.28c.35.002.668-.188.802-.48a.723.723 0 0 0-.19-.851l-4.32-3.893zM20 9.5a2.5 2.5 0 1 1-5.001-.001A2.5 2.5 0 0 1 20 9.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon_image.1ca4ddb695e45c72e79d261520612729.svg";
export { ForwardRef as ReactComponent };